import React, { useEffect } from "react";
import * as F from "../../css/footer/footer";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  return (
    <>
      <F.FooterTop_Stripe className="d-none d-sm-block d-md-block d-lg-block">
        <Container>
          <Row>
            <Col md={4} sm={4} className="m-auto">
              <div className="d-flex justify-content-between">
                <F.FooterTop_Link
                  onClick={() => {
                    navigate("/terms_of_use");
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  이용약관
                </F.FooterTop_Link>
                <F.FooterTop_Link
                  onClick={() => {
                    navigate("/privacy_policy");
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  개인정보처리방침
                </F.FooterTop_Link>
              </div>
            </Col>
          </Row>
        </Container>
      </F.FooterTop_Stripe>
      <div className="d-none d-sm-block d-md-block d-lg-block">
        <Container>
          <Row className="py-5">
            <Col md={4} className="align-self-center text-md-start text-center">
              <div>
                <img 
                 height= "40px"
                 src={process.env.PUBLIC_URL + "/img/footer_logo.svg"} 
                />
              </div>
            </Col>
            <Col md={8} className="text-md-start text-center mt-md-0 mt-4">
              <div>
                <F.FooterBottom_Span className="pe-3 pe-sm-2">
                  주식회사 어셈브릭스
                </F.FooterBottom_Span>
                <F.FooterBottom_SpanBorder className="px-3 px-sm-2">
                  대표자 : 김규태
                </F.FooterBottom_SpanBorder>
                <F.FooterBottom_SpanBorder className="ps-3 ps-sm-2">
                  사업자등록번호 : 409-87-03530
                </F.FooterBottom_SpanBorder>
              </div>
              <div>
                <F.FooterBottom_Span>
                  <b>본사. </b>서울특별시 금천구 가산디지털2로 101, B동 1108호(가산동)
                </F.FooterBottom_Span>      
              </div>
              <div>
                <F.FooterBottom_Span>
                  <b>사업장. </b>서울특별시 강남구 삼성로 570, 석천빌딩 6F
                </F.FooterBottom_Span> 
              </div>
              <div className="py-1">
                <F.FooterBottom_SpanTel>탑탑 고객센터 (평일 09:00 ~ 18:00) : 010-4478-8944</F.FooterBottom_SpanTel>
              </div>
              <div>
                <F.FooterBottom_Span>
                  Copyright ⓒ Assembrix Co.,Ltd. All rights reserved.
                </F.FooterBottom_Span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Footer;
